import BlockProductCard from '@/components/cards/BlockProductCard/index.vue';
export default {
  name: 'ContentBlockProducts',
  components: { BlockProductCard },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    positionCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
